module.exports = __webpack_public_path__ + "static/media/mdir-logo-hvit-eng.db13cc65.svg";